var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10072_25130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C9.15 0 10.15 0.646875 10.6531 1.59687C11.6812 1.28125 12.8438 1.53125 13.6562 2.34375C14.4688 3.15625 14.7188 4.32188 14.4031 5.34688C15.3531 5.85 16 6.85 16 8C16 9.15 15.3531 10.15 14.4031 10.6531C14.7188 11.6812 14.4688 12.8438 13.6562 13.6562C12.8438 14.4688 11.6781 14.7188 10.6531 14.4031C10.15 15.3531 9.15 16 8 16C6.85 16 5.85 15.3531 5.34688 14.4031C4.31875 14.7188 3.15625 14.4688 2.34375 13.6562C1.53125 12.8438 1.28125 11.6781 1.59687 10.6531C0.646875 10.15 0 9.15 0 8C0 6.85 0.646875 5.85 1.59687 5.34688C1.28125 4.31875 1.53125 3.15625 2.34375 2.34375C3.15625 1.53125 4.32188 1.28125 5.34688 1.59687C5.85 0.646875 6.85 0 8 0ZM11.5312 6.53125L12.0625 6L11 4.94063L10.4688 5.47188L7 8.94063L5.53125 7.47188L5 6.94063L3.94062 8L4.47188 8.53125L6.47188 10.5312L7.00313 11.0625L7.53438 10.5312L11.5312 6.53125Z",
    fill: "#5F5FFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10072_25130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.cf6ce4305966a5fbf1b78202e1ae32c4.svg";
export { ForwardRef as ReactComponent };